<template>
  <main class="home">
    <Header
      navbarType="goBack"
      :screenTitle="screenTitle"
      @clicked="goBack()"
    />
    <OptOut />
  </main>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import Header from "@/shared-components/consumer/Header.vue";
import OptOut from "@/apps/credit-line/components/OptOut.vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "CreditLineOptOutView",
  components: { OptOut, Header },
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const screenTitle = ref(t("CL_OPT_OUT.SCREEN_TITLE"));
    const goBack = () => router.back();

    return { t, screenTitle, goBack };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
</style>
